import React from "react";

const Haun = () => (
    <svg
        width="132"
        height="32"
        viewBox="0 0 132 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_13091_7148)">
            <path
                d="M125.979 24.9364L110.2 0.184443L103.596 0.189921L103.688 31.376L108.76 31.3688L108.7 7.43578L123.824 31.3677H130.916L130.828 0.136169L125.747 0.140607L125.979 24.9364Z"
                fill="black"
            />
            <path
                d="M21.9886 13.3963V0.151794H27.2218V31.3683H21.9833V18.4937H5.22782V31.3683H0V0.151794H5.22782V13.3963H21.9886Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M45.9081 0.151794H51.1889L63.7963 31.3683H58.3915L55.5797 24.4038H41.5226L38.7106 31.3683H33.3164L45.9081 0.151794ZM48.5538 7.02308L43.5952 19.2568H53.5043L48.5538 7.02308Z"
                fill="black"
            />
            <path
                d="M81.8386 32.0003C73.9416 32.0003 68.4629 26.9846 68.4629 17.9374V0.151794H73.6961V17.5236C73.6961 23.227 76.944 26.6991 81.9602 26.7166C86.9772 26.7339 90.0343 22.79 90.0343 17.5236V0.151794H95.2146V17.9374C95.2146 26.7079 89.43 32.0003 81.8386 32.0003Z"
                fill="black"
            />
        </g>
        <defs>
            <clipPath id="clip0_13091_7148">
                <rect width="131.2" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default Haun;
